export const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png'];
export const ALLOWED_EXTENSIONS = [...IMAGE_EXTENSIONS, '.pdf'];
